// externals
import { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// internal
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { paymentActionTypes } from '@makemydeal/dr-offer-redux';
import { useBaseDealBreakpoint } from '../../../utils/useBaseDealBreakpoint';
import ClearTaxesButton from './ClearTaxesButton';
import { excludeUnamedTaxes } from './helpers';
import ItemizedTaxesSummary from './ItemizedTaxesSummary';
import { TaxDetailsBaseContainer, TaxOverrideContainer } from './TaxCard.style';
import TaxesBottomBar from './TaxesBottomBar';
import TaxOverride from './TaxOverride';

type TaxDetailsProps = {
    taxOverrideEnabled: boolean;
    setTaxOverrideEnabled: (taxOverride: boolean) => void;
    isTaxesFormDirtyRef?: React.MutableRefObject<boolean>;
};

const TaxDetails = (props: TaxDetailsProps) => {
    const dispatch = useDispatch();
    const { taxOverrideEnabled, setTaxOverrideEnabled, isTaxesFormDirtyRef } = props;
    const offerType = useSelector(offerReduxSelectors.getCurrentOfferType);
    const taxItems = useSelector(offerReduxSelectors.getTaxItemsWithAdjustedRates);
    const allItemizedTaxesWithNames = useMemo(() => excludeUnamedTaxes(taxItems), [taxItems]);
    const [taxOverrideFormEdited, setTaxOverrideFormEdited] = useState(taxOverrideEnabled);
    const handleClearAllTaxes = useCallback(() => {
        dispatch({
            type: paymentActionTypes.CLEAR_TAX_AMOUNTS,
            payload: {
                offerType,
                includeTaxes: false
            },
            meta: { middleware: { payment: true } }
        });
    }, [offerType, dispatch]);

    const BaseBreakPoint = useBaseDealBreakpoint();

    return (
        <>
            {<ClearTaxesButton onClick={handleClearAllTaxes} />}

            <TaxDetailsBaseContainer sx={{ height: '100%' }} BaseBreakPoint={BaseBreakPoint}>
                <ItemizedTaxesSummary
                    data={allItemizedTaxesWithNames}
                    taxOverrideEnabled={taxOverrideEnabled}
                    isTaxesFormDirtyRef={isTaxesFormDirtyRef}
                />
                <TaxOverrideContainer>
                    <TaxOverride
                        taxOverrideEnabled={taxOverrideEnabled}
                        taxOverrideFormEdited={taxOverrideFormEdited}
                        setTaxOverrideEnabled={setTaxOverrideEnabled}
                        setTaxOverrideFormEdited={setTaxOverrideFormEdited}
                    />
                </TaxOverrideContainer>
                <TaxesBottomBar setTaxOverrideFormEdited={setTaxOverrideFormEdited} />
            </TaxDetailsBaseContainer>
        </>
    );
};

export default TaxDetails;
